import { over } from "stompjs";
import SockJS from "sockjs-client";
import { GetSessionToken } from "../../../services/authService";

export const professionalLogInitialState = {
  stompClient: null,
  ws: null,
  activeProfessionals: [],
  isConnecting: false,
};
let userData = null;
const reconnectDelay = 9000;
let fakePositive = true;
let isReconnecting = false;
let isManualClose = false;

const ProfessionalLogReducer = (state, action) => {
  const onPrivateMessageProfessional = (message) => {
    if (userData?.active_role === "PROFESSIONAL" && GetSessionToken()) {
      switch (message?.body) {
        case "ping":
          fakePositive = false;
          state.stompClient.send(
            "/app/pong",
            {},
            JSON.stringify({
              professionalId: userData.email,
              command: "Pong",
            })
          );
          break;
        case "conexion-lost":
          if (state.stompClient && state.stompClient.connected) {
            state.stompClient.disconnect(() => {
              console.error("Desconexion por inactividad");
            });
            action.payload.message.command = "InitialPong";

            attemptReconnect();
          }
          break;
        case "conexion-ended":
          if (state.stompClient && state.stompClient.connected) {
            state.stompClient.disconnect(() => {
              console.error("Desconexion por inactividad");
              // isConnectedWS = false;
              // attemptReconnect();
            });
          }
          break;

        default:
          break;
      }
    }
    return state;
  };
  const checkFakePositive = () => {
    if (fakePositive && !isReconnecting) {
      ProfessionalLogReducer(state, action);
    }
  };
  const connectWS = (state, action) => {
    const UrlWS = process.env.REACT_APP_WS_PARAMETRICS_URL;
    let { mail, userData: _userData, message: initialMessage } = action.payload;
    userData = _userData;
    isManualClose = false;
    const socket = new SockJS(UrlWS);
    fakePositive = true;
    if (state.stompClient && state.stompClient.connected) {
      state.stompClient.disconnect(() => {
        console.error("Desconexion por inactividad");
      });
    }
    state.stompClient = over(socket);
    state.stompClient.connect(
      {},
      (frame) => {
        console.log("Conexión WS exitosa:", frame);
        fakePositive = false;

        state.stompClient.subscribe(
          "/user/" + mail + "/ping",
          onPrivateMessageProfessional
        );
        if (userData?.active_role === "PROFESSIONAL" && GetSessionToken()) {
          state.stompClient.send("/app/pong", {}, JSON.stringify(initialMessage));
          
        } else {
          console.log("Intento de conexion sin tener datos"); 
        }
      },
      (error) => {
        console.error("Error en la conexión WS:", error);
        if (!isManualClose) attemptReconnect();
      }
    );
    setTimeout(() => {
      checkFakePositive();
    }, reconnectDelay * 2);
    return state;
  };


  const connectWSLogin = (state, action) => {
        const { mail, userData: _userData, message: initialMessage } = action.payload;

        userData = _userData;
        isManualClose = false;
        if (userData?.active_role !== "PROFESSIONAL" || !GetSessionToken()) {
           return state;
        }

        if (
          state.ws &&
          state.ws.readyState !== WebSocket.CLOSED &&
          state.ws.readyState !== WebSocket.CLOSING
        ) {
          return state;
        }

        const token = GetSessionToken();
        const url =
          `${process.env.REACT_APP_GATEWAY_URL}/api/ws/professionals` +
          `?name=${userData?.last_name}, ${userData?.first_name}&id_speciality=${userData?.professional_dto?.specialties[0]?.id}&access_token=${token?.value?.id_token}`;

        if (state.ws) {
          state.ws.onclose = null;
          state.ws.close();
        }

        const ws = new WebSocket(url);
        let pingInterval = null;

        ws.onopen = () => {
       
          if (pingInterval == null) {
            pingInterval = setInterval(() => {
              if (ws.readyState === WebSocket.OPEN) {
                ws.send("PING");
                console.log("🏓 Ping enviado");
              }
            }, 30000);
          }
        };

        ws.onmessage = (event) => {
          if (
            typeof event.data === "string" &&
            event.data.startsWith("SESSION_CLOSED:")
          ) {
            const message = event.data.replace("SESSION_CLOSED:", "").trim();

            localStorage.clear();
            sessionStorage.clear();

            ws.close();
            window.location.href = "/login";
            alert(message || "Nueva sesión iniciada en otro dispositivo");
            return;
          }
          try {
            const data = JSON.parse(event.data);
            onPrivateMessageProfessional(data);
          } catch {
            console.log(event.data);
          }
        };

        ws.onerror = (error) => {
          console.error("❌ Error en la conexión WS GATEWAY:", error);
          if (!isManualClose) attemptReconnect();
        };

        ws.onclose = (event) => {
          console.error(
            `Conexión cerrada. code=${event.code}, reason=${event.reason}`
          );

          if (!isManualClose) attemptReconnect();
        };

        return {
          ...state,
          ws,
          isConnecting: true,
        };
  };

  const attemptReconnect = () => {
    if (isManualClose) {
      return;
    }
    if (!isReconnecting) {
      if (state.stompClient?.connected) state.stompClient.disconnect(() => {});
      state.stompClient = null;
      isReconnecting = true; // Marcamos que estamos intentando reconectar
      console.log("Intentando reconectar...");
      setTimeout(() => {
        isReconnecting = false;
        ProfessionalLogReducer(state, action);
      }, reconnectDelay);
    }
  };

  const disconnectWS = (state) => {
    isManualClose = true;
    isReconnecting = false;
    if (state.ws) {
      state.ws.onclose = null;
      state.ws.close();
    }
    if (state.stompClient && state.stompClient.connected) {
      state.stompClient.disconnect(() => {});
    }
    return {
      ...state,
      ws: null,
      stompClient: null,
      isConnecting: false,
    };
  };
  switch (action.type) {
    case "SET_STOMP_CLIENT":
      return {
        ...state,
        stompClient: action.payload,
      };

    case "SEND_MESSAGE":
      let { message } = action.payload;
      state.stompClient?.send("/app/pong", {}, JSON.stringify(message));
      return state;
    case "CONNECT_WS":
      if (userData?.active_role != "PROFESSIONAL" && !GetSessionToken())
        return state;
      if (
        state.isConnecting ||
        (state.ws && state.ws.readyState !== WebSocket.CLOSED && state.ws.readyState !== WebSocket.CLOSING) ||
        (state.stompClient && state.stompClient.connected)
      ) {
        return state;
      }
      return connectWSLogin(state, action);
    case "DISCONNECT_WS":
      return disconnectWS(state);
    default:
      return state;
  }
};

export default ProfessionalLogReducer;
